export enum LocalStorageKeys {
  SIGNUP_REDIRECTS = 'signup_redirects',
  EMAIL = 'email',
}
